'use client';
import ButtonBase from '@mui/material/ButtonBase';
import {styled, type SxProps, type Theme} from '@mui/material/styles';
import type {ReactNode} from 'react';

export interface IconButtonProps {
  'aria-label'?: string;
  children: ReactNode;
  size?: number;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
  type?: 'button' | 'submit';
  disabled?: boolean;
  sx?: SxProps<Theme>;
  className?: string;
}

const Root = styled(ButtonBase, {shouldForwardProp: propName => propName !== 'oSize'})<{oSize?: number}>(({theme, oSize}) => ({
  flexShrink: 0,
  borderRadius: theme.radii.full,
  color: theme.palette.colors.icon.neutral.strong,
  ...(oSize ? {width: oSize, height: oSize} : {padding: theme.spacing(0.5)}),
  '&:focus-visible': {
    outline: `2px solid ${theme.palette.colors.border.focus.default}`,
    outlineOffset: 2,
  },
}));

export function IconButton({size, href, children, sx, ...rest}: IconButtonProps) {
  const elementProps = href ? ({component: 'a', href} as const) : ({component: 'button', type: 'button'} as const);
  return (
    <Root oSize={size} sx={sx} {...elementProps} {...rest}>
      {children}
    </Root>
  );
}

IconButton.displayName = 'IconButton';
